import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

mainNavigationStyles.mobileSearchButton = mergeToNew(mainNavigationStyles.mobileSearchButton, {
    css: css`
        background-color: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
    `,
});
